<template>
  <AdmPanel>
    <h2 slot="header_title">公司管理</h2>
    <div slot="header_buttons" class="adm-buttons">
      <iv-button
        v-rbac-allow="[PERMISSION_RESOURCE,'create']"
        type="primary"
        @click="modal.create.shown=true">
        <iv-icon type="md-add" size="16" />
        <span>新增公司</span>
      </iv-button>
      <iv-button
        v-rbac-allow="[PERMISSION_RESOURCE,'export']"
        :loading="loader[COMPANY+'exportCompany']"
        type="info"
        icon="md-download"
        ghost
        @click="exportExcel()"
      >导出</iv-button>
    </div>
    <FilterBar slot="tools" :value="conditions" :condition="options.filter_rules" @search="changeQuery()">
      <iv-form-item>
        <iv-button :disabled="loader[COMPANY]" type="info" @click="changeQuery()"> <iv-icon type="md-search" size="14" style="vertical-align: text-bottom" /> 查询 </iv-button>
      </iv-form-item>
    </FilterBar>
    <iv-table class="adm-table" :columns="columns" :loading="loader[COMPANY]" :data="list.data"> </iv-table>
    <template v-if="list.last_page > 1">
      <div slot="footer" class="pull-right">
        <iv-page @on-change="pageChanged" :current="list.current_page" :page-size="10" show-elevator show-total :total="list.total"> </iv-page>
      </div>
    </template>

    <router-view></router-view>

    <iv-modal
      v-model="modal.create.shown"
      :title="modal.create.title"
      :width="modal.create.width"
      closable
      @on-cancel="onModalClose('create')"
    >
      <iv-form @submit.native.prevent="">
        <iv-form-item label="搜索现有公司">
          <iv-input
            icon="ios-search"
            type="text"
            placeholder="输入公司名称进行搜索"
            v-model="modal.create.abbreviation"
            @on-keyup="searchCompanyDE"
          />
        </iv-form-item>
        <ul class="adm-list" v-if="!!modal.create.abbreviation">
          <template v-for="item in modal.create.list.data">
            <li :key="item.id">
              <div class="adm-split" style="padding:10px 7px">
                <span>{{ item.abbreviation }}({{ item.stockCode }})</span>
                <router-link :to="{ name:'carbon_company_detail', params:{ stockCode: item.stockCode } }">编辑</router-link>
              </div>
            </li>
          </template>
        </ul>
      </iv-form>
      <div slot="footer">
        <iv-button type="text" size="large" slot="footer" @click="onModalClose('create');modal.create.shown=false">取消</iv-button>
        <router-link slot="footer" :to="{ name:'carbon_company_detail' }">
          <iv-button type="primary" size="large"><iv-icon type="md-add" size="16" />继续新增</iv-button>
        </router-link>
      </div>
    </iv-modal>
  </AdmPanel>
</template>
<script>
import CarbonCompanyModel from "@/models/CarbonCompanyModel";
import CarbonIndustryModel from "@/models/CarbonIndustryModel";

import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import { conditioner, unique, defaultVal, downloadByUrl } from "@/utils/";
import FilterBar from "@/components/FilterBar_X2";
import { companyType,isDelete } from "@/configs/options.conf"
import debounce from "lodash.debounce";

const COMPANY = CarbonCompanyModel.ModelName;
const INDUSTRY = CarbonIndustryModel.ModelName;

const options = {
    year:[],
    industry:[],
    companyType,
    isDelete,
    isDelete_filter: isDelete.filter(i=>[0,1,2,8].indexOf(i.id)> -1),
}

const filter_rules = [
  { name: "industryId", type: "Select", options: [], title: "行业", default: "", placeholder: "行业", clearable: true },
  { name: "companyType", type: "Select", options: options.companyType, title: "上市类型", default: "", placeholder: "上市类型", clearable: true, style: { width: "150px" } },
  { name: "isDelete", type: "Select", options: options.isDelete_filter, title: "公司状态", default: "", placeholder: "公司状态", clearable: true , style: { width: "150px" }},
  { name: "abbreviation", type: "Input", title: "公司简称", default: "", placeholder: "", style: { width: "200px" } },
];

const _conditioner = conditioner(
  {
    //ui到url
    limit: { type: Number, default: 10 },
    industryId: { type: Number, default: "" },
    abbreviation: { type: String, default: "" },
    companyType: { type: Number, default: "" },
    isDelete: { type: Number, default: "" },
  },
  {
    //url到ui
    limit: { type: Number, default: 10 },
    industryId: { type: Number, default: () => "" },
    abbreviation: { type: String, default: "" },
    companyType: { type: Number, default: "" },
    isDelete: { type: Number, default: "" },
  }
);

function columns(vm) {
  const [PERMISSION_RESOURCE] = Object.keys(vm.$route.meta.permissions)
  const allowEdit = vm.$rbac.allow([PERMISSION_RESOURCE, 'edit'])
  const model_type = vm.$route.meta.permissions.hasOwnProperty("listedCompany")? "listed" : ""
  const result = [
    {
      title: "证券代码",
      key: "stockCode",
      align: "center",
      minWidth: 60,
    },
    {
      title: "公司简称",
      key: "abbreviation",
      align: "center",
      minWidth: 120,
    },
    {
      title: "公司全称",
      key: "companyName",
      align: "center",
      minWidth: 150,
    },
    {
      title: "上市类型",
      key: "companyType",
      align: "center",
      minWidth: 90,
      render: (h, params) => {
        let companyType = params.row.companyType;
        const option = options.companyType.find((option) => option.id == companyType);
        if (!option) return <span>—</span>;
        return <span>{option.title}</span>;
      },
    },
    {
      title: "所属行业",
      key: "industry",
      align: "center",
      minWidth: 90,
      render: (h, params) => {
        if(vm.model_type == "listed"){
          return <span>{params.row.industry}</span>
        }else{
          let industryList = params.row.industryList;
          const str = industryList.map((item) => item.industry).join("，");
          return <span>{str}</span>;
        }
      },
    },
    {
      title: "公司状态",
      key: "isDelete",
      align: "center",
      minWidth: 90,
      render: (h, params) => {
        let isDelete = params.row.isDelete;
        const option = options.isDelete.find((option) => option.id == isDelete);
        if (!option) return <span>—</span>;
        return <span>{option.title}</span>;
      },
    },
  ];
  result.push({
    title: "操作",
    key: "tools",
    align: "center",
    minWidth: 140,
    render (h, params) {
      const item = params.row
      const to = { name:'carbon_company_detail', params:{ stockCode: item.stockCode }, query: { redirect:vm.$route.fullPath } }
      const logData = { type:"carbonCompany", stockCode: item.stockCode }
      return (
        <adm-link-group>
          {allowEdit ? <router-link to={ to }>编辑</router-link> : ""}
          <a href="javascript:;" onClick={ ()=>vm.$operationLog.show(logData) }>查看日志</a>
        </adm-link-group>
      )
    }
  })
  return result
}
export default {
  name: "company",
  mixins: [
    LoaderMixin(COMPANY, INDUSTRY, COMPANY+'exportCompany'),
    ModelMixin({
      contact,
      models: [CarbonCompanyModel, CarbonIndustryModel],
    }),
  ],
  data() {
    const [PERMISSION_RESOURCE] = Object.keys(this.$route.meta.permissions)
    const model_type = this.$route.meta.permissions.hasOwnProperty("listedCompany")? "listed" : "";
    return {
      PERMISSION_RESOURCE,
      model_type,
      columns: columns(this),
      conditions: {
        ..._conditioner.default(),
      },
      COMPANY,
      INDUSTRY,
      list: {
        data: [],
        last_page: 0,
        current_page: 1,
      },
      options: {
        ...options,
        filter_rules,
      },
      industries: [],
      modal: {
          create: {
            shown: false,
            title: "新增公司",
            width: 600,
            abbreviation: "",
            list: {}
          }
      }
    };
  },
  async mounted() {
    const { query, params } = this.$route;
    this.conditions = _conditioner.serialize({ ...query, ...params }); //处理成支持UI的格式
    await this.refreshIndustry();
    this.refresh();
  },
  beforeRouteUpdate(to, from, next) {
    this.$nextTick(async () => {
      const { query, params } = to;
      this.conditions = {
        ..._conditioner.default(),
        ..._conditioner.serialize({ ...query, ...params }), //处理成支持UI的格式
      };
      this.refresh();
    });
    next();
  },
  methods: {
    searchCompanyDE: debounce(function(){ this.searchCompany() } ,250),
    async refresh(query = this.conditions) {
      this.list = await this.$$fetch(COMPANY, { type:this.model_type, ..._conditioner.parse(query) });
      this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1;
      this.list.last_page = this.list.total / _conditioner.parse(query).limit;
    },
    async refreshIndustry(params = this.$route.params) {
      const industry = await this.$$fetch(INDUSTRY, { type:this.model_type,...params });
      const rule = this.options.filter_rules.find((item) => item.name == "industryId");
      rule.options = this.industries = industry.data.map((item) => ({ ...item, title: item.industry }));
    },
    async searchCompany(query={abbreviation: this.modal.create.abbreviation}){
      this.modal.create.list = await this.$$fetch(COMPANY, { allTab:1, type:this.model_type, ..._conditioner.parse(query) });
      this.modal.create.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1;
      this.modal.create.list.last_page = this.modal.create.list.total / _conditioner.parse(query).limit;
    },
    pageChanged(page) {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: (page - 1) * _conditioner.parse(this.conditions).limit }, params: this.$route.params });
    },
    mergeQuery(query) {
      return { ...this.conditions, ...query };
    },
    changeQuery(query = this.conditions, params = this.$route.params) {
      this.$router.push({
        name: this.$route.name,
        query: { ..._conditioner.parse(query), offset: 0 },
        params: params,
      });
    },
    onModalClose(type){
      if(type=='create'){
        this.modal.create.abbreviation = ""
        this.modal.create.list = { data:[] }
      }
    },
    async exportExcel(query = this.conditions) {
      // TODO:
      console.log("exportExcel...", this.conditions)
      const res = await this.$$active(COMPANY, 'exportCompany', {type:this.model_type,..._conditioner.parse(query) })
      if(!res.data.url) {
        this.$$info('后台未返回url，请重试')
        return
      }
      // 下载链接
      downloadByUrl(res.data.url)
    },
  },
  components: {
    FilterBar,
  },
};
</script>
<style lang="postcss" scoped>
.inline-checkList {
  display: inline-block;
  margin-right: 20px;
}
.inline-checkList >>> span {
  display: inline-block !important;
}

.inline-checkList >>> div {
  display: inline-block !important;
}
</style>
